/**
 * @Author: zhangxiaojian
 * @Date: 2025/9/29
 * @LastEditors: zhangxiaojian
 * @Description 注册用户权限相关信息
 **/

import * as apis from '../apis'
import EventBus from '../common/EventBus'
import { EventBusDataKey } from '../common/GlobalEvent'
import { routeIdTable } from './route-config'
import userPermission from '../common/userPermission'

class registerAuths {
  /**
   * 获取权限信息
   */
  async getAuths() {
    let notRulePages = [] // 无权限的页面
    if (window.processEnvMode !== 'RR') {
      // 剔除云雀中存在但云端稿库不存在权限
      notRulePages = await userPermission.getNotRulePages()
    }
    let res = await apis.MediaCloudGateway.getPortals()
    if (res.data.status === 0) {
      if (window.processEnvMode !== 'RR') {
        res.data.data.groups.forEach((item) => {
          item.subs = this.filterModGroups(item.subs, notRulePages)
        })
      }
      if (res.data.data.auth) {
        // 权限数组信息
        EventBus.setData(
          EventBusDataKey.AUTH.AUTHS,
          res.data.data.auth.map((item) => item.code)
        )
        // 存储用户mods权限信息
        EventBus.setData(EventBusDataKey.AUTH.MODS, res.data.data.auth)
      }
      EventBus.setData(EventBusDataKey.AUTH.USER, res.data.data.user)
      this.buildPortalGroups(res.data.data.groups)
    }
  }

  /**
   * 过来无效菜单
   * @param {Array} menuList 当前菜单
   * @param {Array} removeRule 移除规则
   * @returns {*}
   */
  filterModGroups(menuList, removeRule) {
    return menuList
      .filter((item) => {
        return removeRule.indexOf(item.source) === -1
      })
      .map((item) => {
        item = Object.assign({}, item)
        if (item.mods) {
          item.mods = this.filterModGroups(item.mods, removeRule)
          if (item.mods.length === 0) {
            item = null
          }
        }
        return item
      })
      .filter((item) => !!item)
  }
  /**
   * 构建菜单分组，将路由绑定到菜单树上，处理路由和菜单对应问题，由于后台返回的模块树各级节点顺序不确定，通过存储各级菜单index的方式会导致路由和最终渲染的模块不匹配，所以各级list增加以item.id为key的item引用，改为存储已选模块的id
   * @param groups
   * @returns {*}
   */
  buildPortalGroups(groups) {
    const defineProperty = Object.defineProperty
    groups._mods = []
    // 判断第一个页面是否是系统管理（绝了啊这需求
    EventBus.setData(EventBusDataKey.AUTH.FIRST_GROUPS_IS_SYSTEM, false)
    for (let i = 0; i < groups.length; i++) {
      const group = groups[i] // 一个页面
      group.id = 'page' + group.id
      group.casId = group.id
      defineProperty(groups, group.id, {
        get() {
          return group
        }
      })
      // 遍历页面下的一级导航
      const children = group.subs
      if (!children) continue
      this.resolveSub(children, group, function findMod(mod) {
        if (!group.route) {
          group.route = mod.route
          group.routeId = mod.casId
        }
        // 这里经过输出验证 会便利处理第三级所以可以这样判断
        if (i === 0 && mod.source === 'admin-user') {
          EventBus.setData(EventBusDataKey.AUTH.FIRST_GROUPS_IS_SYSTEM, true)
        }
        groups._mods.push(mod)
        defineProperty(groups._mods, mod.id, {
          get() {
            return mod
          }
        })
      })
    }
    EventBus.setData(EventBusDataKey.AUTH.GROUPS, groups)
  }

  /**
   * 遍历页面下的一级导航
   * @param {Array} subs 子集导航列表
   * @param {Object} parent 父级对象
   * @param {Function} findMod 回调执行方法
   * @returns {{source}|*}
   */
  resolveSub(subs, parent, findMod) {
    for (let j = 0; j < subs.length; j++) {
      const defineProperty = Object.defineProperty
      const sub = subs[j]
      const parentCasId = parent.casId
      const parentName = parent.name

      sub.id = 'sub' + sub.id
      sub.casId = parentCasId + '-' + sub.id
      sub.casName = parentName + '-' + sub.name
      if (sub.source) {
        // 判断是否是功能模块并添加路径
        this.resolveMod(sub)
        findMod(sub)
      }

      defineProperty(subs, sub.id, {
        get() {
          return sub
        }
      })
      const children = sub.mods || sub.subs
      if (!children) continue
      this.resolveSub(children, sub, function (mod) {
        if (!sub.route) {
          sub.route = mod.route
          sub.routeId = mod.casId
        }
        findMod(mod)
      })
    }
  }

  /**
   * 获取mod数据
   * @param {Object} mod 权限数据
   */
  resolveMod(mod) {
    const routeConfig = routeIdTable.find((config) => config.mod === mod.source)
    mod.route = routeConfig?.route ?? ''
  }
}

export default registerAuths
